/**
 * Where this app is mounted: "/help" in production, "" when the dev server is
 * opened directly (localhost:3000/...).
 *
 * The build sets PUBLIC_URL=/help, so production always reads it from there.
 * react-scripts 3 blanks PUBLIC_URL in development, which is right for the bare
 * dev server but not when the local nginx (deployment/nginx.local.conf) mounts
 * it at /help next to a running hanamaru -- the way production is routed. In
 * that case the URL itself says so.
 */
const HELP = "/help";

function detectMount() {
  if (process.env.PUBLIC_URL) return process.env.PUBLIC_URL;
  if (typeof window === "undefined") return "";

  const { pathname } = window.location;
  return pathname === HELP || pathname.indexOf(`${HELP}/`) === 0 ? HELP : "";
}

export const MOUNT_PATH = detectMount();

/** True when the storefront is served from this same origin. */
export const BESIDE_STOREFRONT = MOUNT_PATH === HELP;
